import { clientI18n } from '../../../../shared/scripts/ClientI18n.ts';
import { createDivIn, setElementOnClick } from '../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIMFullscreenPageView } from '../../ui_page/UIMFullscreenPageView.ts';
import { uiManager } from '../../EntryMobile.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export class UIMFullscreenTabView extends UIMFullscreenPageView {
    buildView() {
        const tabContainer = createDivIn(this.body, 'm-tabs-container');
        this.tabProperties.map((tabInfo, idx)=>{
            const tab = createDivIn(tabContainer, 'm-tab');
            tab.innerText = clientI18n.t(tabInfo.title.key, tabInfo.title.options);
            if (tabInfo.isActive) tab.classList.add('m-tab-active');
            const container = createDivIn(this.body, tabInfo.containerClass);
            if (!tabInfo.isActive) container.classList.toggle('hidden');
            this.tabs.push(tab);
            this.containers.push(container);
            setElementOnClick(tab, ()=>this.updateActiveTabToIndex(idx));
            if (tabInfo.isActive) this.activeTabIdx = idx;
        });
        if (this.buttonText) this.createButtons();
    }
    createButtons() {
        this.continueButton = createDivIn(this.body, 'm-continue-button');
        this.continueButton.innerText = clientI18n.t('strings:game.endGame.footer.continue');
    }
    setOnClickContinueButton(callback) {
        if (this.continueButton == undefined) return;
        setElementOnClick(this.continueButton, ()=>{
            AudioManager.play(AudioType.Click);
            let isLastPage = false;
            let updatedTabIdx = this.activeTabIdx + 1;
            if (updatedTabIdx >= this.tabs.length) {
                updatedTabIdx = 0;
                isLastPage = true;
            }
            callback(isLastPage);
            this.updateActiveTabToIndex(updatedTabIdx);
        });
    }
    updateActiveTabToIndex(idx, playSound = false) {
        this.tabs[this.activeTabIdx].classList.remove('m-tab-active');
        this.containers[this.activeTabIdx].classList.toggle('hidden');
        const tab = this.tabs[idx];
        const container = this.containers[idx];
        tab.classList.add('m-tab-active');
        container.classList.toggle('hidden');
        if (playSound) AudioManager.play(AudioType.Click);
        this.activeTabIdx = idx;
        if (this.onTabChange) this.onTabChange(this.activeTabIdx);
        this.updateContinueButton();
    }
    updateContinueButton() {
        var _this_buttonText;
        if (!this.continueButton) return;
        if (!this.buttonText) return;
        const isLastTab = this.activeTabIdx == this.tabs.length - 1;
        this.continueButton.className = isLastTab ? 'm-create-room-button' : 'm-continue-button';
        this.continueButton.innerText = isLastTab ? clientI18n.t(this.buttonText.key, (_this_buttonText = this.buttonText) === null || _this_buttonText === void 0 ? void 0 : _this_buttonText.options) : clientI18n.t('strings:game.endGame.footer.continue');
    }
    getContainerWithTabIdx(idx) {
        return this.containers[idx];
    }
    setTabTitle(idx, text) {
        this.tabs[idx].innerText = clientI18n.t(text.key, text.options);
    }
    constructor(title, tabProperties, buttonText, onTabChange){
        super(title, 'room', ()=>uiManager.createRoomController.onExitRoom()), this.tabs = [], this.containers = [];
        this.tabProperties = tabProperties;
        this.buttonText = buttonText;
        this.shouldHideOnBackButton = false;
        this.onTabChange = onTabChange;
        this.build(true);
    }
}
